// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"0c9beba3","453":"9afe920c","576":"bf877842","642":"0ccef2d3","645":"a5c4fe90","687":"a9011cd1"}[chunkId] + ".chunk.js";
};